import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { Subject } from 'rxjs';

import { SidebarWrapperComponent } from '../components/sidebar-wrapper/sidebar-wrapper.component';
import {
  SwitchExternalUserSidebarContentComponent
} from './components/switch-external-user-sidebar-content/switch-external-user-sidebar-content.component';
import { SwitchExternalUserStore } from './state/switch-external-user-store/switch-external-user-store.service';
import { SidebarDisplayStore } from '../../stores/signal-stores/sidebar-display-store/sidebar-display.store';

@Component({
  selector: 'app-switch-external-user-sidebar',
  imports: [
    SidebarWrapperComponent,
    TranslocoDirective,
    SwitchExternalUserSidebarContentComponent
  ],
  providers: [
    SwitchExternalUserStore
  ],
  templateUrl: './switch-external-user-sidebar.component.html',
  styleUrl: './switch-external-user-sidebar.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SwitchExternalUserSidebarComponent implements OnDestroy {
  protected readonly sidebarDisplayStore = inject(SidebarDisplayStore);
  protected primaryActionClicked$ = new Subject<void>();

  public ngOnDestroy(): void {
    this.primaryActionClicked$.complete();
  }

  public onActionButtonClicked(): void {
    this.primaryActionClicked$.next();
  }

  public closeSidebar(): void {
    this.sidebarDisplayStore.hideSwitchExternalUserSidebar();
  }
}
